import posthog from "posthog-js";
import { getUser, isPremiumUser } from "../login/auth_utils";

/**
 * service used for tracking and analytics
 */
class PosthogService {
  /* ------------------------------------------------------------------ */
  /*  PUBLIC API                                                        */
  /* ------------------------------------------------------------------ */

  /** Initialise PostHog exactly once (call this in `src/index.js`). */
  static init() {
    try{
    console.log("going to initialize posthog tracking service")
    if (this._initialised) return;           // guard

    posthog.init('phc_jn1buKuY55qaYqo49ZxmbMH7RRayfyu7So1rtYiXK38',
      {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'identified_only' // or 'always' to create profiles for anonymous users as well
      }
    )

    this._initialised = true;
    this._identifyFromLocalStorage();        // auto-identify if user already cached
    console.log("posthog tracking already initialized")
    }catch(ex){
        console.log(ex)
    }
}

  /** Track a custom event. */
  static capture(eventName, props = {}) {
    try{
    posthog.capture(eventName, props);
    }catch(ex){
        console.log(ex)
    }
  }

  /** Call after login/signup; merges the anonymous cookie with the real user. */
  static identify(user) {
    try{
    if (!user?.userId) return;
    posthog.identify(user.email, {
        $userId:user.userId.toString(),
         $email: user.email,
         $isPremium: isPremiumUser()
         });
    console.log("posthog user identified")
    }catch(ex){
        console.log(ex)
    }
  }

  /** Call on logout; clears cookie & starts a fresh anonymous session. */
  static logout() {
    try{
    posthog.reset();
    console.log("posthog reset/logout done")
    }catch(exception){
        console.log(exception)
    }
    // If your app also clears localStorage, do it here
    // localStorage.removeItem('user');
  }

  /* ------------------------------------------------------------------ */
  /*  INTERNALS                                                         */
  /* ------------------------------------------------------------------ */

  /** Reads localStorage and identifies the user if we have one cached. */
  static _identifyFromLocalStorage() {
    try {
     // const raw = localStorage.getItem('user');
     // if (!raw) return;
      const user = getUser() //JSON.parse(raw);
      this.identify(user);
    }catch(ex){
        console.log(ex)
    }
  }
}

export default PosthogService;